import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const NotFoundComponent = () => {
	const location = useLocation();

	useEffect(() => {
		console.error('404 Error: ', location.pathname);
	}, [location.pathname]);

	return (
		<div className="flex min-h-screen items-center justify-center bg-muted">
			<div className="text-center">
				<h1 className="mb-4 text-4xl font-bold">404</h1>
				<p className="mb-4 text-xl text-muted-foreground">الصفحة غير موجودة ! </p>
				<a href="/" className="text-primary underline hover:text-primary/90">
					العودة
				</a>
			</div>
		</div>
	);
};

export default NotFoundComponent;
